<template>
    <div>
        <panel-ms class="panel__shadow-hover"> 
            <router-link :to="'/news/item/'+item.id">   
                <img :src="item.src" alt="">
            </router-link>
        </panel-ms>
        <h3 :class="main?'two-lines':''">{{item.header }}</h3>
        <p>{{item.data_news_t}}</p>
    </div>
</template>
<script>
import panelMs from '../common/panelMs.vue';
export default{
    components:{
        panelMs
    },
    props:{
        item:{type:Object,default:null},
        main:{type:Boolean,default:false}
    },
   
}
</script>
<style>
.news__panel {
    display: flex;
    gap:32px
}
.news__panel img{
    height: 212px;
    width: 306px;
}
.news__panel img{
    object-fit: cover;
}
.news__panel h3{
    color:#0D3041 ;
    font-size: 14px;
    height: 36px;
    overflow: hidden;
    width: 306px;
    margin-top: 16px;
    margin-bottom: 8px;
    text-overflow: ellipsis;
}
.news__panel h3.two-lines{
    -webkit-line-clamp: 2; /* Число отображаемых строк */
    display: -webkit-box; /* Включаем флексбоксы */
    -webkit-box-orient: vertical; /* Вертикальная ориентация */
}
.news__panel p{
    margin: 0;
    font-size: 14px;
    font-weight: 400;
    line-height: 130%;
    color: #919191;
}   
</style>